import { defineRule, configure } from 'vee-validate';
import * as rules from '@vee-validate/rules';

import { i18n } from './i18n'


Object.keys(rules).forEach(rule => {
    // Excluir propiedades especiales y no-funciones
    if (rule === "default" || 
        rule === "__esModule" || 
        rule === "all" ||
        typeof rules[rule] !== 'function') {
        return;
    }
    // Solo registrar funciones válidas
    defineRule(rule, rules[rule]);
});

configure({
    generateMessage: function (context) {
        context.field = i18n.global.t('fields.' + context.field).toLowerCase();
        return i18n.global.t('validations.' + context.rule.name, context);
    }
})